import React from "react";
import { formatIdDateTime } from "@/lib/format";

// Display-only panel: shows the audit trail of admin plate-number
// overrides applied to an SPB. Rendered only when the SPB has at least
// one entry in `plate_overrides`.
export default function PlateOverridesPanel({ overrides }) {
  if (!overrides?.length) return null;
  return (
    <div className="border border-amber-500/40 bg-amber-50/30 mb-8" data-testid="plate-overrides-panel">
      <div className="p-4 border-b border-amber-500/30 flex items-center gap-2 bg-amber-100/40">
        <span className="text-amber-700 font-bold uppercase text-xs tracking-widest">⚠ Riwayat Ganti Plat</span>
        <span className="text-xs text-amber-800 font-mono">({overrides.length}×)</span>
      </div>
      <div className="divide-y divide-amber-500/20">
        {overrides.map((ov, i) => (
          <div
            key={`${ov.at || i}-${ov.new_no_polisi || ""}`}
            className="p-4 grid grid-cols-1 md:grid-cols-[auto_1fr] gap-x-6 gap-y-1 text-sm"
            data-testid={`plate-override-${i}`}
          >
            <div className="font-mono font-bold text-amber-800">
              <span className="line-through opacity-60">{ov.old_no_polisi}</span>
              <span className="mx-2">→</span>
              <span>{ov.new_no_polisi}</span>
            </div>
            <div className="text-xs text-muted-foreground">
              <span className="font-mono">{formatIdDateTime(ov.at)}</span>
              {ov.at_status && (
                <span className="ml-2 uppercase text-[10px] tracking-wider border border-amber-500/40 px-1.5 py-0.5">{ov.at_status}</span>
              )}
            </div>
            <div className="col-span-full md:col-span-1" />
            <div>
              <span className="text-muted-foreground">Alasan: </span>
              <span className="italic">"{ov.reason}"</span>
            </div>
            <div className="col-span-full md:col-span-1" />
            <div className="text-xs text-muted-foreground">
              Oleh <span className="font-semibold">{ov.by_name || ov.by}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
